import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type StockStatusClasses = 'container' | 'statusIcon' | 'text' | 'inStock' | 'noStock';

const stockStatusStyles = makeStyles<ISpcTheme, StockStatusClasses>(
  ({ breakpoints, palette }) => ({
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',

      [breakpoints.down('xs')]: {
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    statusIcon: {
      display: 'inline',
      width: 10,
      height: 10,
      borderRadius: '50%',
      backgroundColor: palette.primary.light,
      margin: '0 4px',
    },
    text: {
      display: 'inline-flex',
      flexDirection: 'row',
      alignItems: 'center',
      wordBreak: 'break-word',
      flexWrap: 'wrap',
      width: '100%',

      '& span': {
        fontWeight: 'bold',
      },
    },
    inStock: {
      textTransform: 'capitalize',
    },
    noStock: {
      paddingLeft: 6,
    },
  }),
  { name: 'Customise_StockStatus' },
);

export default stockStatusStyles;
